import { Link } from 'react-router';

import { ROUTES } from '@/shared/config';
import { LeaderboardList } from '@/widgets/leaderboard-list';

import styles from './RatingPage.module.scss';

/** «Рейтинг» (узел 438:51329). */
export function RatingPage() {
  return (
    <div className={styles.page}>
      <div className={styles.titleRow}>
        <Link className={styles.back} to={ROUTES.home} aria-label="Назад">
          <img src="/images/matches/back.svg" alt="" aria-hidden className={styles.backIcon} />
        </Link>
        <h1 className={styles.title}>Рейтинг</h1>
      </div>

      <LeaderboardList />
    </div>
  );
}
